import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=8f002600&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f002600",
  null
  
)

export default component.exports